import { createAction, props } from '@ngrx/store';
import { Cart, CartDetails } from 'src/app/utility/model/cart';

export const getCart = createAction('[Cart] Get Cart');

export const getCartSuccess = createAction(
  '[Cart] Get Cart Success',
  props<{ cartDetails: CartDetails }>(),
);

export const getCartFailure = createAction(
  '[Cart] Get Cart Failure',
  props<{ error: any }>(),
);

export const setSpinner = createAction(
  '[Cart] Set Spinner',
  props<{ spinner: boolean }>(),
);

export const updateCartAll = createAction(
  '[Cart] Update Cart All',
  props<{
    cartDetails?: CartDetails;
    cartCount?: number;
    cartStatus?: string;
    cartItems?: Cart[];
  }>(),
);

export const setRefreshCart = createAction(
  '[Cart] Set Refresh Cart',
  props<{ refreshCart: string }>(),
);

export const clearMovedToEmptyCartFlag = createAction(
  '[Cart] MOVED_TO_EMPTY_CART',
);
